<template>
  <v-tooltip
    :open-on-hover="true"
    location="top" :open-delay="300"
    content-class="text-neutral0 bg-neutral900"
    :disabled="isMobile"
  >
    <span>{{ t('bulk.actions.select') }}</span>
    <template #activator="{ props }">
      <BrandButton
        variant="secondary"
        color="neutral25"
        class="text-neutral900"
        flat
        v-bind="{ ...props, ...toolbarBtnProps, ...$attrs }"
      >
        <PhChecks class="text-h5" />
        <span v-if="!isCompact" class="ml-3">{{ t('bulk.actions.select') }}</span>
      </BrandButton>
    </template>
  </v-tooltip>
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify'
import { PhChecks } from '@phosphor-icons/vue'
import { useToolbarButtonStyle } from '@/composables/useToolbarButtonStyle'

defineOptions({ inheritAttrs: false })

const { t } = useI18n()
const display = useDisplay()
const isMobile = computed(() => display.smAndDown.value)
const { isCompact, toolbarBtnProps } = useToolbarButtonStyle()
</script>
